import React from 'react';
import { PhoneToCnpBookingDetails } from '../PhoneToCnpEntities';
import { ShareViaSMS } from './ShareComponents/ShareViaSMS';
import { CopyLinkSection } from './ShareComponents/CopyLinkSection';
import './ShareBookingIvr.scss';

interface ShareBookingIvrProps {
    booking: PhoneToCnpBookingDetails;
    onClose: () => void;
}

export const ShareBookingIvr: React.FC<ShareBookingIvrProps> = ({ booking, onClose }) => {
    return (
        <div className="share-booking-ivr-panel">
            <p className="subtitle">Share your trip in real time with family or friends.</p>

            <ShareViaSMS booking={booking} />

            <hr className="section-divider" />

            <CopyLinkSection shareUrl={booking.BookingShareUrl} />
        </div>
    );
};
